import React from 'react'

export default function Copyrights({ appProps }) {
  return (
    <div className='copyrights'>
      Powered by <a href={ appProps.instanceUrl }
                    target="_blank"
                    rel="nofollow noindex noreferrer">
                      { appProps.instanceName }
                  </a>
    </div>
  )
}
